export const createHandleClearServices = <T>(
  onServicesChange: (services: T[]) => void
) => {
  return () => {
    onServicesChange([]);
  };
};
